const securityTrain = {
  path: 'securityTrain/:pages',
  component: resolve => require(['../../../../pages/modules/securityTrain'], resolve),
  meta: {
    requireAuth: true
  }
}

export default securityTrain
